import colors from "../base/colors";

const datagrid = {
  styleOverrides: {
    root: {
      backgroundColor: colors.white.main,
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: colors.white.main,
      },
      "& .MuiDataGrid-cell:focus": {
        outline: "none",
      },
    },
    row: {
      "&.MuiDataGrid-row.Mui-even": {
        backgroundColor: colors.grey[100],
      },
      "&.MuiDataGrid-row.Mui-odd": {
        backgroundColor: colors.white.main,
      },
      "&.MuiDataGrid-row:hover": {
        backgroundColor: colors.grey[200],
      },
    },
  },
};
export default datagrid;
